export type YouTubeEmbedBlockProps = {
  src: string;
  key?: string;
  title?: string;
};

export const YouTubeEmbedBlock: React.FC<YouTubeEmbedBlockProps> = ({
  src,
  key = null,
  title = "YouTube video player",
}) => (
  // eslint-disable-next-line tailwindcss/no-custom-classname
  <div className="chromatic-ignore relative w-full overflow-hidden pt-[56.25%]">
    <iframe
      className="absolute left-0 top-0 size-full"
      src={src}
      key={key}
      title={title}
      allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
      referrerPolicy="strict-origin-when-cross-origin"
      allowFullScreen
    ></iframe>
  </div>
);
